module.exports = __webpack_public_path__ + "media/images/brasileirao-a029c82dee1fe4fa5e2abc57204f6237.png";